import { ApplicationError } from 'models/Error';
import { emailVarification } from 'repositories/emailVerification';
import { Success, Result } from 'types';

export class EmailVerificationDomain {
  static async createTransaction(
    email: string
  ): Promise<Result<string, ApplicationError>> {
    try {
      const response = await emailVarification.create(email);
      return new Success(response.transaction_key);
    } catch (e) {
      return ApplicationError.handleForRepositoryError(e);
    }
  }

  static async validateTransaction(
    transactionKey: string,
    code: string
  ): Promise<Result<string, ApplicationError>> {
    try {
      const response = await emailVarification.validate(transactionKey, code);
      return new Success(response.transaction_key);
    } catch (e) {
      return ApplicationError.handleForRepositoryError(e);
    }
  }
}
